import { render, staticRenderFns } from "./CellSlot.vue?vue&type=template&id=35232763"
import script from "./CellSlot.vue?vue&type=script&lang=js"
export * from "./CellSlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports